import { stringifyQs } from "@saleor/utils/urls";

export const pendingOrderUrl = "/pending-order";
export const pendingOrderTrackingUrl = "/pending-order-tracking";

import { Pagination, Sort } from "@saleor/types";

export enum PendingOrderListSortField {
  soldTo = "soldTo",
  poNo = "poNo",
  soNo = "soNo",
  shipTo = "shipTo",
  orderDate = "orderDate",
  confirmDate = "confirmDate",
  itemNo = "itemNo",
  materialCode = "materialCode",
  materialDescription = "materialDescription",
  orderQty = "orderQty",
  pendingQty = "pendingQty",
  atpQty = "atpQty",
  ctpQty = "ctpQty",
  deliveryQty = "deliveryQty",
  saleUnit = "saleUnit"
}

export type PendingOrderUrlSort = Sort<PendingOrderListSortField>;
export type PendingOrderUrlQueryParams = Pagination & PendingOrderUrlSort;

export const PendingOrderListUrl = (params?: PendingOrderUrlQueryParams) =>
  pendingOrderUrl + "?" + stringifyQs(params);

export const PendingOrderTrackingListUrl = (
  params?: PendingOrderUrlQueryParams
) => pendingOrderTrackingUrl + "?" + stringifyQs(params);
